// extracted by mini-css-extract-plugin
export default {"homeContainer":"homeContainer--3WwCv","topFold":"topFold--GsDiR"};